export const locale = {
  lang: "en-CA",
  data: {
    SELECT_PLACE: {
      TITLE: "Select an internal room",
      SELECTED_ROOM: "Selected room",
    },
  },
};
